import { useState } from 'react'
import BackdropModal from 'Shared/components/BackdropModal/BackdropModal'
import './EmbedModal.scoped.scss'

function buildIframeSnippet(embedUrl) {
  return `<iframe src="${embedUrl}" style="width:100%;border:0;min-height:600px;" loading="lazy"></iframe>`
}

export default function EmbedModal({ open, onCancel, publicUrl, status }) {
  const [copied, setCopied] = useState(false)

  const embedUrl = publicUrl ? `${publicUrl.replace(/\/$/, '')}/embed` : ''
  const snippet = buildIframeSnippet(embedUrl)
  const isLive = status === 'live'

  function onCopy() {
    if (!navigator?.clipboard) return
    navigator.clipboard.writeText(snippet).then(() => {
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    })
  }

  return (
    <BackdropModal open={open} onCancel={onCancel} title="Embed this page">
      <div className="embed-modal form">
        {!isLive && (
          <p className="error embed-warning">
            <SvgIconsWarning width={18} height={18} />
            <span>This page is not live, so the embed will not render for visitors yet.</span>
          </p>
        )}

        <p>
          Paste the snippet below into your website to embed this page's form.
          Only the form will be shown — none of the page's surrounding chrome.
        </p>

        <div className="field">
          <label>Embed snippet</label>
          <textarea
            readOnly
            rows={3}
            value={snippet}
            onClick={(e) => e.target.select()}
            style={{ width: '100%', fontFamily: 'monospace' }}
          />
          <button type="button" className="button secondary" onClick={onCopy} style={{ marginTop: 8 }}>
            {copied ? 'Copied' : 'Copy snippet'}
          </button>
        </div>
      </div>
    </BackdropModal>
  )
}
